import { render } from "./ContenutoBancale.vue?vue&type=template&id=09d957c5"
import script from "./ContenutoBancale.vue?vue&type=script&lang=js"
export * from "./ContenutoBancale.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__